import { render } from "./IconContentCopy.vue?vue&type=template&id=1a437860"
import script from "./IconContentCopy.vue?vue&type=script&lang=js"
export * from "./IconContentCopy.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icons/IconContentCopy.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a437860"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a437860', __exports__)) {
    api.reload('1a437860', __exports__)
  }
  
  module.hot.accept("./IconContentCopy.vue?vue&type=template&id=1a437860", () => {
    api.rerender('1a437860', render)
  })

}


export default __exports__